import React from 'react';

import { IconProps } from './types';
import styles from './../styles/icon.css';

const FolderStarIcon: React.FC<IconProps> = props => {
  let svgAttrs;
  if (props.fill) {
    svgAttrs = { fill: props.fill };
  } else {
    svgAttrs = { className: styles.iconSvgPath };
  }

  return (
    <svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.3"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.5 20.125H20.5C21.3284 20.125 22 19.4814 22 18.6875V8.14583C22 7.35192 21.3284 6.70833 20.5 6.70833H10L7.43934 4.25436C7.15804 3.98478 6.7765 3.83333 6.37868 3.83333H3.5C2.67157 3.83333 2 4.47692 2 5.27083V18.6875C2 19.4814 2.67157 20.125 3.5 20.125Z"
        {...svgAttrs}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 16.5099L9.80187 17.6672C9.53879 17.8057 9.2134 17.7044 9.07509 17.4409C9.02001 17.336 9.00101 17.2158 9.02102 17.099L9.44081 14.6478L7.66252 12.9118C7.44968 12.7041 7.44533 12.3628 7.65279 12.1497C7.73541 12.0648 7.84366 12.0096 7.96078 11.9925L10.4183 11.6349L11.5174 9.40473C11.6489 9.1378 11.9716 9.02821 12.2381 9.15995C12.3443 9.2124 12.4302 9.29844 12.4826 9.40473L13.5816 11.6349L16.0391 11.9925C16.3333 12.0353 16.5371 12.3088 16.4943 12.6034C16.4773 12.7207 16.4222 12.8291 16.3374 12.9118L14.5591 14.6478L14.9789 17.099C15.0292 17.3924 14.8324 17.671 14.5395 17.7213C14.4228 17.7413 14.3028 17.7223 14.1981 17.6672L12 16.5099Z"
        {...svgAttrs}
      />
    </svg>
  );
};

export default FolderStarIcon;
